// extracted by mini-css-extract-plugin
export default {"cSection":"Section_cSection__3hOH1"};